// extracted by mini-css-extract-plugin
module.exports = {"productsGroupPage":"ProductGroupPage-module--products-group-page--k3mGR","content":"ProductGroupPage-module--content--3r3-Q","bottom":"ProductGroupPage-module--bottom--3zZyT"};